// extracted by mini-css-extract-plugin
module.exports = {"container":"hhEbtiFD","title":"hMreOfwX","itemsContainer":"wKaTIO4A","item":"SRsCdA3I","label":"hXOqJJxu"};